/* ==========================================================================
   CLIBINO — cart-drawer.js (reescrito desde cero, Ajax Cart API)
   Carrito en lateral. Cada acción (añadir, sumar, restar, quitar) espera
   siempre a la respuesta real de Shopify antes de repintar, bloquea los
   botones mientras hay una petición en curso para evitar dobles clics, y
   nunca deja un estado a medias si algo falla.
   ========================================================================== */

(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  var itemsEl = document.querySelector('[data-cart-items]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var shippingBarFill = document.querySelector('[data-shipping-bar-fill]');
  var shippingBarText = document.querySelector('[data-shipping-bar-text]');
  var freeShippingThreshold = parseInt((drawer && drawer.dataset.freeShippingThreshold) || '5000', 10);

  var busy = false; // evita que dos peticiones al carrito se pisen entre sí

  function formatMoney(cents) {
    if (window.AmansaFormatMoney) return window.AmansaFormatMoney(cents);
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Propiedades de la línea (ej. "Color unidad 1: Blanco"): sin esto el
     cliente elige un color por unidad en la ficha de producto pero no
     vuelve a verlo en ningún sitio tras añadirlo, y parece que su elección
     "no se ha guardado" aunque sí viaje al pedido. Se ignoran las claves
     que empiezan por "_" (metadatos internos, no pensados para el cliente). */
  function propertiesHtml(properties) {
    if (!properties) return '';
    var lines = Object.keys(properties)
      .filter(function (key) {
        var value = properties[key];
        return value !== null && value !== '' && key.indexOf('_') !== 0;
      })
      .map(function (key) {
        return '<p class="cart-line__prop">' + escapeHtml(key) + ': ' + escapeHtml(properties[key]) + '</p>';
      });
    return lines.join('');
  }

  function open() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function setBusy(value) {
    busy = value;
    if (itemsEl) itemsEl.classList.toggle('is-updating', value);
  }

  function render(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (shippingBarFill) {
      var remaining = Math.max(0, freeShippingThreshold - cart.total_price);
      var pct = Math.min(100, (cart.total_price / freeShippingThreshold) * 100);
      shippingBarFill.style.width = pct + '%';
      if (shippingBarText) {
        shippingBarText.innerHTML = remaining > 0
          ? 'Estás a <strong>' + formatMoney(remaining) + '</strong> del envío gratis'
          : '<strong>Envío gratis conseguido 🎉</strong>';
      }
    }

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Tu carrito está en calma, todavía sin nada dentro.</p></div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      html += ''
        + '<div class="cart-line" data-line="' + item.key + '" data-quantity="' + item.quantity + '">'
        + '  <img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">'
        + '  <div class="cart-line__info">'
        + '    <p class="cart-line__title">' + item.product_title + '</p>'
        + (item.variant_title ? '    <p class="cart-line__variant">' + item.variant_title + '</p>' : '')
        + propertiesHtml(item.properties)
        + '    <div class="cart-line__qty">'
        + '      <button type="button" data-cart-qty-change data-direction="decrease" data-line="' + item.key + '" aria-label="Restar unidad">–</button>'
        + '      <span>' + item.quantity + '</span>'
        + '      <button type="button" data-cart-qty-change data-direction="increase" data-line="' + item.key + '" aria-label="Sumar unidad">+</button>'
        + '    </div>'
        + '    <button type="button" class="cart-line__remove" data-cart-remove data-line="' + item.key + '">Quitar</button>'
        + '  </div>'
        + '  <strong>' + formatMoney(item.final_line_price) + '</strong>'
        + '</div>';
    });
    itemsEl.innerHTML = html;
  }

  function refresh() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function postCart(url, payload) {
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    });
  }

  function addItems(items) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return postCart('cart/add.js', { items: items })
      .then(function (result) {
        if (!result.ok) {
          console.error('CLIBINO cart error:', result.data && result.data.description);
        }
        return refresh();
      })
      .then(function () { open(); })
      .catch(function (err) { console.error('CLIBINO cart error:', err); })
      .finally(function () { setBusy(false); });
  }

  function changeLine(lineKey, quantity) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return postCart('cart/change.js', { id: lineKey, quantity: quantity })
      .then(function (result) {
        if (!result.ok) {
          console.error('CLIBINO cart error:', result.data && result.data.description);
        }
        render(result.data);
      })
      .catch(function (err) {
        console.error('CLIBINO cart error:', err);
        return refresh();
      })
      .finally(function () { setBusy(false); });
  }

  function submitProductForm(form) {
    if (busy) return;
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    var originalLabel = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Añadiendo…'; }
    setBusy(true);

    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          console.error('CLIBINO cart error:', result.data && result.data.description);
        }
        return refresh();
      })
      .then(function () { open(); })
      .catch(function (err) { console.error('CLIBINO cart error:', err); })
      .finally(function () {
        setBusy(false);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalLabel; }
      });
  }

  // --- Delegación de eventos: un único listener para todo el documento ---

  // El navegador enfoca un <button> en el "mousedown", antes de que llegue
  // el "click" — y al enfocarlo, si queda parcialmente tapado por el header
  // fijo o el propio layout del carrito, hace scroll automático para
  // llevarlo a la vista. Ese salto ocurría en cada +/-/quitar del carrito
  // porque el preventDefault() del click llega demasiado tarde para
  // evitarlo. Cancelando el mousedown de estos botones, el clic se sigue
  // procesando igual mas el botón nunca roba el foco ni dispara ese scroll.
  document.body.addEventListener('mousedown', function (e) {
    if (e.target.closest('[data-cart-qty-change], [data-cart-remove], [data-cart-add-simple]')) {
      e.preventDefault();
    }
  });

  document.body.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-cart-drawer-open]');
    var closeTrigger = e.target.closest('[data-cart-drawer-close]');
    var quickAdd = e.target.closest('[data-cart-add-simple]');
    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    var removeBtn = e.target.closest('[data-cart-remove]');

    if (openTrigger) { e.preventDefault(); open(); return; }
    if (closeTrigger || e.target === overlay) { close(); return; }

    if (quickAdd) {
      e.preventDefault();
      addItems([{ id: quickAdd.dataset.variantId, quantity: parseInt(quickAdd.dataset.quantity || '1', 10) }]);
      return;
    }

    if (qtyBtn) {
      e.preventDefault();
      if (busy) return; // ignora clics mientras hay una petición en curso
      var line = itemsEl.querySelector('[data-line="' + CSS.escape(qtyBtn.dataset.line) + '"]');
      var current = parseInt((line && line.dataset.quantity) || '1', 10);
      var next = qtyBtn.dataset.direction === 'increase' ? current + 1 : Math.max(0, current - 1);
      changeLine(qtyBtn.dataset.line, next);
      return;
    }

    if (removeBtn) {
      e.preventDefault();
      if (busy) return;
      changeLine(removeBtn.dataset.line, 0);
      return;
    }
  });

  document.body.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    submitProductForm(form);
  });

  document.body.addEventListener('amansa:add-bundle', function (e) {
    addItems(e.detail.items);
  });

  // Mantiene compatibilidad con el nombre usado en el resto del theme.
  window.AmansaCartDrawer = { open: open, close: close, refresh: refresh };
})();
